import http from "./http";

class UsersService {
    index(token){
        return http.get("/api/users")
    }

    index_users(){
        return http.get("/api/frontend/users")
    }

    store(data){
        return http.post("/api/users/store", data)
    }

    edit(id,token){
        return http.get(`/api/users/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/users/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/users/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/users/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    /*getTotalUser(){
        return http.get("/api/users/frontend")
    }*/
}

export default new UsersService()